import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import styles from './dashboard-container.scss'
import { topBannerSelector, userSelector } from 'src/selectors'
import { useSelector, useDispatch } from 'react-redux'
import MenuBar from '../components/MenuBar/MenuBar'
import HeaderBar from 'components/HeaderBar/HeaderBarV2'
import cn from 'classnames'
import DownloadAppBanner from 'components/global/DownloadAppBanner'
import queryString from 'query-string'
import { updateMenuPanel } from 'src/actions/frontend'
import { PanelSlug } from 'components/MenuBar/panels/PanelContainer'
import { isMobile } from 'services/browser_detection'
import { isHobnobAndroidClient } from 'src/services/utils'

function DashboardContainer(props) {
  const { children, title, visibleHeaderBar, documentTitle } = props
  const dispatch = useDispatch()
  const { visible: isBannerVisible } = useSelector(topBannerSelector)
  const user = useSelector(userSelector)
  const menuBarRef = useRef(null)
  const headerBarRef = useRef(null)

  useEffect(() => {
    document.title = documentTitle
  }, [documentTitle])

  useEffect(() => {
    handleUrlParams()
  }, [user])

  const handleUrlParams = () => {
    const parsedUrl = new URL(window.location.href)
    const params = queryString.parse(parsedUrl.search)
    if (params.from === 'corp-site') {
      if (isMobile()) {
        headerBarRef.current.onSetIsHeaderSliderVisible(true)
      } else {
        menuBarRef.current.onSetIsMenuSliderVisible(true)
      }
      dispatch(updateMenuPanel(user ? PanelSlug.Profile : PanelSlug.Login))
    }
  }
  const isAndroidApp = isHobnobAndroidClient()
  return (
    <div className={styles['container']}>
      {visibleHeaderBar && !isAndroidApp && (
        <section>
          <HeaderBar ref={headerBarRef} {...props}>
            {title}
          </HeaderBar>
        </section>
      )}

      {isBannerVisible && !isAndroidApp && <DownloadAppBanner />}

      <section className={cn('web-view', styles['menu-container'])}>
        <MenuBar ref={menuBarRef} />
      </section>
      <section className={styles['dashboard-section']}>{children}</section>
    </div>
  )
}

DashboardContainer.defaultProps = {
  visibleHeaderBar: true,
  documentTitle: 'Hobnob'
}

DashboardContainer.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  visibleHeaderBar: PropTypes.bool,
  documentTitle: PropTypes.string
}

export default DashboardContainer
